import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertTriangle, FiRefreshCcw} = FiIcons;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null, errorInfo: null};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error, errorInfo});
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="max-w-2xl w-full bg-white rounded-xl shadow-xl border border-red-100 p-8">
            <div className="flex items-center space-x-4 mb-6 text-red-600">
              <SafeIcon icon={FiAlertTriangle} className="text-4xl" />
              <h1 className="text-2xl font-bold">Something went wrong</h1>
            </div>
            <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-8">
              <p className="text-slate-700">
                The application encountered an unexpected issue. Please reload the page and try again.
                If the issue continues, contact BPA Solutions support.
              </p>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="flex items-center justify-center w-full px-4 py-3 bg-slate-900 hover:bg-slate-800 text-white rounded-lg font-medium transition-colors"
            >
              <SafeIcon icon={FiRefreshCcw} className="mr-2" />
              Reload Application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;